import { ApiService } from "./api";

const apiService = new ApiService();
apiService.setApiUrl("/contract_fields");

export const contractFieldService = {
  add,
  //remove,
  find,
  addGroup,
  removeGroup,
};

async function add(item) {
  return apiService.add(item);
}

/* async function remove(item) {
  return apiService.remove(item.id);
}
 */
async function find(id) {
  return apiService.find(id);
}

async function addGroup(data, template) {
  return apiService.addGroup(data, template);
}

async function removeGroup(ids) {
  return apiService.removeGroup(ids);
}
